import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalBody,
    ModalCloseButton,
    Button,
    HStack,
    Box,
    Link,
    Icon,
} from '@chakra-ui/react';
import { MdOpenInNew } from 'react-icons/md';

interface PDFPreviewModalProps {
    isOpen: boolean;
    onClose: () => void;
    pdfUrl: string | null;
    title?: string;
    page?: number;
}

export function PDFPreviewModal({ isOpen, onClose, pdfUrl, title = 'Document Preview', page }: PDFPreviewModalProps) {
    if (!pdfUrl) return null;

    const iframeSrc = page ? `${pdfUrl}#page=${page}` : pdfUrl;

    return (
        <Modal isOpen={isOpen} onClose={onClose} size="6xl" scrollBehavior="inside">
            <ModalOverlay backdropFilter="blur(2px)" />
            <ModalContent h="90vh">
                <ModalHeader>
                    <HStack justify="space-between" pr={8}>
                        <Box>{title}</Box>
                        <Link href={pdfUrl} isExternal>
                            <Button size="sm" variant="ghost" rightIcon={<Icon as={MdOpenInNew} />}>
                                Open in New Tab
                            </Button>
                        </Link>
                    </HStack>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody p={0} h="full">
                    <Box w="100%" h="100%" bg="gray.100">
                        <iframe
                            src={iframeSrc}
                            width="100%"
                            height="100%"
                            style={{ border: 'none' }}
                            title="PDF Preview"
                        />
                    </Box>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
}

